import type { Nullable } from 'corgi-types';
import type { Shop, ShopLegalInfo } from 'graphql-ts-types';

import type { CartMessageCode } from 'common/enums/Cart';
import type { DyBannerVoucherProps } from '../../banner-voucher/components/CommonBannerVoucher';
import type { ProductCardItem } from '../../cart-product-list/components/ProductCard';
import type {
  CartAttributesFragment,
  CartMessageFragment,
  CartResponseFragment,
  ShippingInfoV4AttributesFragment,
} from '../gql/generated/schema';

export interface CartItem {
  article: { sku: string };
}

export type ShopLegalInfoItem = Pick<ShopLegalInfo, 'title' | 'key'>;

interface CartItemShopInfo extends Pick<Shop, 'id' | 'name'> {
  ratings?: Shop['ratings'];
  legalInfo?: ShopLegalInfoItem[];
  shippingInfo_v4: Nullable<ShippingInfoV4AttributesFragment>;
}

export interface CartItemsGroupItem extends Omit<ProductCardItem, 'selectedOffer'> {
  selectedOffer?: ProductCardItem['selectedOffer'];
}

export interface CartItemsGroup {
  items: CartItemsGroupItem[];
  isHome24?: boolean;
  shop?: CartItemShopInfo;
  shippingSubTotal: number;
}

export interface CartItems {
  itemsGroups: CartItemsGroup[];
}

export interface Cart extends CartItems {
  shippingTotal: number;
  grandTotal: number;
  totalItems: number;
  subTotal: number;
  taxTotal: number;
  discountTotal: number;
}

export interface CartMessage extends CartMessageFragment {
  code: CartMessageCode;
}

export interface CartDyCampaign {
  voucherBanner: Nullable<DyBannerVoucherProps>;
}

export enum CartUpdateStatus {
  Loading = 'loading',
  Success = 'success',
  FinishedLoading = 'finishedLoading',
}

export type CartUpdateState =
  | {
      status: CartUpdateStatus.Loading;
    }
  | {
      status: CartUpdateStatus.FinishedLoading;
    }
  | {
      status: CartUpdateStatus.Success;
      transformed: false;
      cart: CartResponseFragment['cart'];
      messages: Nullable<CartMessage[]>;
    }
  | {
      status: CartUpdateStatus.Success;
      transformed: true;
      cartAttributes: CartAttributesFragment;
    };
